import React, {Fragment} from 'react'
import styles from '../Categories/styles.module.css'
import BrandBar from './BrandBar'

export default function Categories(props) {
  if (!props.categories) return null

  let lastBrandId = null

  return (
    <div className={styles.brandsContainer}>
      {props.categories.map(category => {
        let brand = null
        if (category.brand && category.brand._id !== lastBrandId) {
          brand = category.brand
          lastBrandId = brand._id
        }

        const brandContent = brand ? (
          <BrandBar
            brand={brand}
            onClick={() => {
              props.onClick()
              props.scrollTo(category._id)
            }}
          />
        ) : null

        if (!category.brand && lastBrandId) {
          lastBrandId = null
        }
        return <Fragment key={category._id}>{brandContent}</Fragment>
      })}
    </div>
  )
}
